import angular from 'angular';
import loansCatalogCardButtonsComponent from './loansCatalogCardButtons.component';

let loansCatalogCardButtonsModule = angular.module('loansCatalogCardButtons', [
])

.component('loansCatalogCardButtons', loansCatalogCardButtonsComponent)

.name;

export default loansCatalogCardButtonsModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalogCard/loansCatalogCardButtons/loansCatalogCardButtons.js